<template>
    <div class="p-grid">
        <Toast />
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('Purchase.list.AddPurchase') }}</strong>
                </h4>
                <div class="p-formgrid p-grid p-mb-3">
                    <div class="p-field p-col-12 p-md-3">
                        <label for="title">{{ $t('Purchase.list.Email') }}</label>
                        <InputText id="title" type="text" :class="`${errorValue.email ? 'p-invalid' : ''}`"
                            :placeholder="$t('Purchase.list.SBEmail')" v-model="email" />
                        <div class="text-red">{{ errorValue.email }}</div>
                    </div>
                </div>

                <div class="p-d-flex p-jc-between p-ai-lg-center p-ai-start p-mt-6 p-flex-column p-flex-lg-row">
                    <div class="p-mb-4 p-mb-lg-0">
                        <!-- <Button :label="$t('button.today')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="today"></Button>
                        <Button :label="$t('button.lastWeek')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastweek"></Button>
                        <Button :label="$t('button.lastMonth')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastmonth"></Button>
                        <Button :label="$t('button.last6Months')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastsixmonth"></Button>
                         <Button :label="$t('button.lastYear')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastyear"></Button>  -->
                    </div>
                    <div class="p-mb-4 p-mb-lg-0">
                        <Button :label="$t('button.search')" icon="pi pi-search" iconPos="left"
                            class="p-button p-component p-button p-button-sm p-mr-2 p-mb-2"
                            v-on:click="isHidden = !isHidden" @click="SearchPurchase"></Button>
                        <Button :label="$t('button.reset')" icon="pi pi-replay" iconPos="left"
                            class="p-button p-component p-button p-button-sm p-mr-2 p-mb-2" @click="resetUser"></Button>
                    </div>
                </div>
            </div>
        </div>

        <div class="p-col-12">
            <div class="card p-fluid" v-if="isHidden && errorValue == ''" id="formcard">
                <!-- <h4>
                    <strong>{{ $t('Purchase.Add.Heading') }}</strong>
                </h4> -->
                <div class="p-formgrid p-grid p-mb-3">
                    <div class="p-field p-col-12 p-md-3">
                        <label for="SurTitle">{{ $t('Purchase.Add.Company Name') }}</label>
                        <InputText id="SurTitle" type="text" :placeholder="$t('Purchase.Add.Company Name')"
                            v-model="company_name" disabled />
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="SurTitle">{{ $t('Purchase.Add.Phone') }}</label>
                        <InputText id="SurTitle" type="text" :placeholder="$t('Purchase.Add.Phone')"
                            v-model="user_phone_number" disabled />
                    </div>
                </div>
                <div class="p-formgrid p-grid p-mb-3">
                    <div class="p-field p-col-12 p-md-3">
                        <label for="surveyURL">{{ $t('Purchase.Add.AdType') }}</label>
                        <Dropdown v-model="ad_type_id" :class="`${error.ad_type_id ? 'p-invalid' : ''}`"
                            :options="Typesdropdown" optionLabel="korean" optionValue="id"
                            :placeholder="$t('Purchase.list.Select')" name="name" id="first_category" />
                        <div class="text-red">{{ error.ad_type_id }}</div>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="SurTitle">{{ $t('Purchase.Add.AdSubType') }}</label>
                        <Dropdown v-model="ad_sub_type_id" :class="`${error.ad_sub_type_id ? 'p-invalid' : ''}`"
                            :options="SubTypesdropdown" optionLabel="sub_type" optionValue="id"
                            :placeholder="$t('Purchase.list.Select')" name="name" id="first_category"
                            @click="getSubTypes" @change="Details(ad_sub_type_id)" />
                        <div class="text-red">{{ error.ad_sub_type_id }}</div>
                    </div>
                </div>
                <div class="p-formgrid p-grid p-mb-3">
                    <div class="p-field p-col-12 p-md-3">
                        <label>{{ $t('Purchase.Add.ValidTime') }}</label>
                        <InputText id="surveyURL" type="text" :placeholder="$t('Purchase.Add.ValidTime')"
                            v-model="validity_date" disabled />
                    </div>
                    <div class="p-field p-col-12 p-md-3" v-if="ad_type_id == '7'">
                        <label for="SurTitle">{{ $t('Purchase.Add.NoCases') }}</label>
                        <InputText id="SurTitle" type="text" :placeholder="$t('Purchase.Add.NoCases')"
                            v-model="no_of_cases" disabled />
                    </div>
                </div>
                <div class="p-d-flex p-jc-end p-ai-center" style="float: left; margin-left:0px;"
                    v-if="email !== ''">
                    <Button :label="$t('notice1.Add.Save')" class="p-button p-button p-mr-2 p-mb-2 enable"
                        @click="AddPurchase" icon="pi pi-check" iconPos="left" style="background: black;color: white;"></Button>
                </div>
                <!-- <div class="p-d-flex p-jc-end p-ai-center" style="float: left; margin-left:20px" v-else>
                <Button :label="$t('notice1.Add.Save')" class="p-button p-button-sm p-mr-2 p-mb-2 disable"
                    @click="AddPurchase"></Button>
            </div> -->
            </div>

            <div class="p-col-12">
                <div class="card p-fluid" v-if="isHidden1">
                    <div class="p-formgrid p-grid p-mb-3">
                        <div class="p-field p-col-12 p-md-12">
                            <h4 id="Nodata">데이터를 찾을 수 없습니다.</h4>
                        </div>
                    </div>
                </div>
                <div class="p-d-flex p-jc-end p-ai-center" style="float: right; margin-right:20px">
                    <Button :label="$t('notice1.Add.Back')" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2"
                        @click="$router.go(-1)" icon="pi pi-replay" iconPos="left" style="background: white; color: black;"></Button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import validateAddPurchase from '../../validations/Purchase/validateAddPurchase';
import validatePurchaseEmail from '../../validations/Purchase/validatePurchaseEmail'
import PurchaseService from '../../service/API/PurchaseService';
import axios from 'axios';
export default {
    data() {
        return {
            selected: [],
            selectedItemss: '',
            render: true,
            display: false,
            position: 'center',
            visibleLeft: false,
            visibleRight: false,
            visibleTop: false,
            visibleBottom: false,
            visibleFull: false,
            customer1: null,
            loading1: false,
            idFrozen: false,
            products: null,
            expandedRows: [],
            user: null,
            error: {},
            errorValue: {},
            //params for list
            status: '',
            user_phone_number: '',
            company_name: '',
            email: '',
            isHidden: false,
            isHidden1: false,
            Typesdropdown: null,
            Typesdropdowns: '',
            SubTypesdropdown: null,
            SubTypesdropdowns: '',
            ad_type_id: '',
            sub_type: '',
            ad_sub_type_id: '',
            ad_type: '',
            no_of_cases: '',
            validity_date: '',
            user_id: ''
        };
    },
    customerService: null,
    productService: null,
    created() {
        this.purchaseService = new PurchaseService();
    },
    mounted() {
        // this.getlist();
        this.purchaseService
            .GetAddTypeList()
            .then((data) => {
                let data1 = data.data.result;
                
               
                // console.log(data1)
                data1[0].korean = '긴급';
                data1[1].korean = '프리미엄';
                data1[2].korean = '스페셜';
                data1[3].korean = '라인';
                data1[4].korean = '업글';
                data1[5].korean = '인재 검색';
                this.loading1 = false;
                this.Typesdropdown = data1;
                // console.log(data1)
                // this.Typesdropdown = data.data.result;
            })
    },
    watch: {},
    methods: {
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        AddPurchase() {
            // alert(this.user_id)
            let vcheckData = {
                ad_type_id: this.ad_type_id.toString(),
                ad_sub_type_id: this.ad_sub_type_id.toString(),
                user_id: this.user_id,
                sub_type: this.sub_type,
                validity_date: this.validity_date,
                no_of_cases: this.no_of_cases,
            };
            const { isInvalid, error } = validateAddPurchase(vcheckData);
            if (isInvalid) {
                this.error = error;
                // this.isHidden = true;
                // console.log(error);
            } else {
                this.error = '';
                // this.isHidden = true;
                // console.log(this.modelname);
                return axios.post('api/v1/admin/purchase/add-purchase', { ad_type_id: this.ad_type_id, ad_sub_type_id: this.ad_sub_type_id, user_id: this.user_id, sub_type: this.sub_type, validity_date: this.validity_date, no_of_cases: this.no_of_cases }).then(() => {
                    // alert('Tag added successfully.');
                    this.$router.push({ name: 'Purchase Management' });
                    setTimeout(() => {
                        this.$toast.add({ severity: 'success', summary: '확인.', detail: '알림이 성공적으로 추가되었습니다.', life: 3000 });
                    }, 500);
                });
            }
        },
        getSubTypes() {
            this.purchaseService.GetAddSubTypeList(this.ad_type_id).then((res) => {
                this.SubTypesdropdown = res.data.result;
                // console.log(res.data.result);

            });
        },
        Details(ad_sub_type_id) {
            // console.log(ad_sub_type_id)
            this.purchaseService.viewSubTypeDetails(ad_sub_type_id).then((result) => {
                // console.log(result);
                this.validity_date = result[0].validity_date;
                this.sub_type = result[0].sub_type;
                this.no_of_cases = result[0].no_of_cases;
            });
        },
        SearchPurchase() {
            // if (this.email == '') {
            //     this.isHidden = false;
            //     // console.log(this.productCategoryStatus);
            //     // this.$toast.add({ severity: 'error', summary: 'Error message', detail: '1개 이상의 검색 값을 입력하세요.', life: 3000 });
            //     this.error = error

            // } else {
            let vcheckData = {
                email: this.email,

            };
            const { isInvalid, errorValue } = validatePurchaseEmail(vcheckData);
            if (isInvalid) {
                this.isHidden = false;
                this.errorValue = errorValue;
                console.log(errorValue);
            } else {
                this.errorValue = '';
                this.isHidden = true;
                let searchParams = {
                    email: this.email,
                };
                this.purchaseService
                    .SearchPurchase(searchParams)
                    .then((res) => {
                        // console.log(res)
                        if (res.data.result.length === 0) {
                            // console.log(res.data.result.length)
                            this.isHidden1 = true;
                            this.isHidden = false;
                        } else {
                            this.isHidden1 = false;
                            this.isHidden = true;
                            this.results = res.data.result;
                            this.company_name = res.data.result[0].company_name;
                            this.user_phone_number = res.data.result[0].user_phone_number;
                            this.user_id = res.data.result[0].user_id
                            // console.log(res);
                            // console.log(res.data.result[0].user_id);
                            // console.log(res.data.result[0].user_phone_number);
                        }
                    })
                    .catch(() => {
                        this.results = [];
                    });
            }
            // }
        },

        resetUser() {
            this.email = '';
            this.errorValue = '';
            this.company_name = '';
            this.user_phone_number = '';
            this.ad_sub_type_id = '';
            this.ad_type_id = '';
            this.validity_date = '';
            this.no_of_cases = '';
            this.isHidden = false;
            this.isHidden1 = false;
        },

        lastweek() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 7);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
        },
        lastmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 31);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
        },
        lastsixmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 182);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
        },
        exceldownload() {
            this.selects();
            this.userService.downloadExcel(this.name, this.mobile, this.email, this.calendarValue, this.calendarValue1, this.selectedItemss).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Userlist.xlsx'); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },

        toggle(event) {
            this.$refs.op.toggle(event);
        },

        onRowExpand(event) {
            this.$toast.add({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
        },
        onRowCollapse(event) {
            this.$toast.add({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
        },
        expandAll() {
            this.expandedRows = this.products.filter((p) => p.id);
            this.$toast.add({ severity: 'success', summary: 'All Rows Expanded', life: 3000 });
        },
        collapseAll() {
            this.expandedRows = null;
            this.$toast.add({ severity: 'success', summary: 'All Rows Collapsed', life: 3000 });
        },
        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },
        formatDate(value) {
            const date = new Date(value);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (value = yyyy + '.' + mm + '.' + dd);
        },
        calculateCustomerTotal(name) {
            let total = 0;
            if (this.customer3) {
                for (let customer of this.customer3) {
                    if (customer.representative.name === name) {
                        total++;
                    }
                }
            }

            return total;
        },
    },
};
</script>

<style lang="scss" scoped>
.p-datatable-tbody {
    .p-button {
        white-space: nowrap;
    }
}

.p-fluid {
    .p-button {
        width: auto;
    }
}

.p-button.enable {
    color: #fff;
    background: #000;
    border: 0px;
}


.p-button.disable {
    color: #000;
    background: #ddd;
    cursor: not-allowed;
    border: 0px;
}

.p-button:focus {
    box-shadow: none;
}
h4#Nodata {
    text-align: center;
}
div#formcard {
    height: 90%;
}
</style>
